import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import ObjectiveHistoryServices from "./ObjectiveHistory.services";
import { ResponsiveEmbed } from "react-bootstrap";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const resetObjectiveHistory = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_OBJECTIVE_HISTORY,
      payload: true,
    });
    dispatch({
      type: actions.GET_OBJECTIVE_HISTORY,
      payload: {
        objectiveHistories: [],
        objectiveHistoriesLength: 0,
      },
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.OBJECTIVE_HISTORY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_OBJECTIVE_HISTORY,
      payload: false,
    });
  }
};


export const getObjectiveHistory = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_OBJECTIVE_HISTORY,
      payload: true,
    });
    const resp = await ObjectiveHistoryServices.getObjectiveHistory(data);
    dispatch({
      type: actions.GET_OBJECTIVE_HISTORY,
      payload: {
        objectiveHistories: resp.data.historial || [],
        objectiveHistoriesLength: resp.data.historial.length || 0,
      },
    });
    dispatch({
      type: actions.OBJECTIVE_HISTORY_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.OBJECTIVE_HISTORY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_OBJECTIVE_HISTORY,
      payload: false,
    });
  }
};
